import { $ } from "@/common/Axios";

export default {
  /**
   * MCP OAuth 授权
   */
  token: {
    /*
     * 令牌端点
     */
    post: (p, c) => $.post("/api/mcp/oauth/token", p, c),
  },

  /**
   * MCP OAuth 授权
   */
  revoke: {
    /*
     * 撤销令牌
     */
    post: (p, c) => $.post("/api/mcp/oauth/revoke", p, c),
  },

  /**
   * MCP OAuth 授权
   */
  register: {
    /*
     * 动态客户端注册（RFC 7591）
     */
    post: (p, c) => $.post("/api/mcp/oauth/register", p, c),
  },

  /**
   * MCP OAuth 授权
   */
  introspect: {
    /*
     * 令牌内省
     */
    post: (p, c) => $.post("/api/mcp/oauth/introspect", p, c),
  },

  /**
   * MCP OAuth 授权
   */
  device_verify: {
    /*
     * 设备确认页
     */
    get: (p, c) => $.get("/api/mcp/oauth/device_verify", p, c),

    /*
     * 设备确认提交
     */
    post: (p, c) => $.post("/api/mcp/oauth/device_verify", p, c),
  },

  /**
   * MCP OAuth 授权
   */
  device_authorization: {
    /*
     * 设备授权申请
     */
    post: (p, c) => $.post("/api/mcp/oauth/device_authorization", p, c),
  },

  /**
   * MCP OAuth 授权
   */
  consent: {
    /*
     * 同意 / 拒绝
     */
    post: (p, c) => $.post("/api/mcp/oauth/consent", p, c),
  },

  /**
   * MCP OAuth 授权
   */
  clients_revoke: {
    /*
     * 解除客户端授权
     */
    post: (p, c) => $.post("/api/mcp/oauth/clients/revoke", p, c),
  },
  clients: {
    /*
     * 已授权客户端列表
     */
    get: (p, c) => $.get("/api/mcp/oauth/clients", p, c),
  },

  /**
   * MCP OAuth 授权
   */
  pending: {
    /*
     * 同意页读取待授权请求
     */
    get: (p, c) => $.get("/api/mcp/oauth/pending", p, c),
  },

  /**
   * MCP OAuth 授权
   */
  authorize: {
    /*
     * 授权请求入口
     */
    get: (p, c) => $.get("/api/mcp/oauth/authorize", p, c),
  },
};
